import { IFeaturesSpecification, IConfiguratorUIDto } from '@canvas-logic/clp-api-types';

export function getFeatures(view: IConfiguratorUIDto): IFeaturesSpecification {
  const defaults: IFeaturesSpecification = {
    webAr: { enabled: false },
    canvasLogicBranding: { enabled: false },
    info: { enabled: true },
    share: { enabled: true },
  };
  return {
    ...defaults,
    ...view.features,
    info: view.features?.info ?? defaults.info,
    share: view.features?.share ?? defaults.share,
  };
}

export function isWebArEnabled(view: IConfiguratorUIDto) {
  const features = getFeatures(view);
  return Boolean(features.webAr.enabled);
}

export function isCanvasLogicBrandingEnabled(view: IConfiguratorUIDto) {
  const features = getFeatures(view);
  return Boolean(features.canvasLogicBranding.enabled);
}

export function isInfoEnabled(view: IConfiguratorUIDto) {
  const features = getFeatures(view);
  return Boolean(features.info.enabled);
}

export function isShareEnabled(view: IConfiguratorUIDto) {
  const features = getFeatures(view);
  return Boolean(features.share.enabled);
}

export function getCanvasLogicBrandingLink(view: IConfiguratorUIDto): string {
  const features = getFeatures(view);
  if (features.canvasLogicBranding.link) {
    return features.canvasLogicBranding.link;
  } else {
    return features.canvasLogicBranding ? 'https://canvaslogic.de/en/augmented-reality-product-configurator/' : '';
  }
}
